import React from "react";
import { Container} from 'react-bootstrap';
import { Route, Routes} from "react-router-dom";
import Login from "./Auth/Login";
import ProtectedPage from "./ProtectedPage/ProtectedPage";
import Register from "./Auth/Register";
import HomeContent from "./Home/Home";
import About from "./About/About";
import Contact from "./Contact/Contact";

function Main() {
    return <Container fluid className="mt-3">
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/protected" element={<ProtectedPage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<HomeContent />} />
            <Route path="/about" element={<About/>}/>
            <Route path="/contact" element={<Contact/>}/>
        </Routes>
    </Container>
}

export default Main